module.exports = __webpack_public_path__ + "static/media/Kevin_Ton_Resume.bad37978.pdf";